
/**
 * @name Block.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\Block.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null, userHasRole = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;
        userHasRole = utils.userHasRole;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'financeiro/caixa')
            return;

        new FinancialCashFlow(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class FinancialCashFlow
{
    constructor(onloadList=false, deps = {})
    {
        
        this.deps = deps;
        let self = this;
        this.tableHandler = new TableBuilder({
            table: '#table-financial-cash-flow-list',
            tableBody: '.js-financial-cash-flow-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-financial-cash-flow-per-page option:selected').val()),
            filter: false,
            maxPages: 0,
            customId: "CrudCashFlowHandler",
            tableRowRenderer: function(rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function() {
                self.fetchCashFlowList();
            },
            OnClickLastPage: function() {
                self.fetchCashFlowList();
            },
        });

        getSecUsers(users => {
            console.log('users', users);
            let html = '<option value="" selected disabled>-- Selecione --</option>';
            users.forEach(user => {
                html += `<option value="${user.LOGIN}">${user.LOGIN}</option>`;
            });
            $('.js-financial-cash-flow-registrations-requester').html(html);
            $('select[name="cashflow_edit_requester"]').html(html);
        });
        
        this.fetchCashFlowList();
        this.bindDomTableAndFilterEvents();
        this.bindDomEvents();
        this.bindDOMCashFlowUploads();
    }

    fetchCashFlowList() {
        let self = this;
        $(".js-financial-cash-flow-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest = apiCall({
            method: 'GET',
            endpoint: 'api/v1/financial/cash-flow',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-financial-cash-flow-per-page option:selected').val()),
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {},
                ...self.serviceId !== '' && self.serviceId !== null ? { serviceId: self.serviceId } : {}
            },
            successCallback: function(res) {
                $(".js-financial-cash-flow-registrations-table").unblock();
                if (!res.error) {
                    self.financialCashFlowList = res.data;
                    self.financialCashFlowTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.financialCashFlowList, false, self.financialCashFlowTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function(err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow = (cashflow) => {
        let row = `<tr>
            <td>${cashflow.ID}</td>
            <td>${getBranchNameFromId(cashflow.FILIAL_ID)}</td>
            <td>${cashflow.DATA_CAIXA}</td>
            <td>${cashflow.DATA_UPLOAD}</td>
            <td>${cashflow.USUARIO_UPLOAD}</td>
            <td>${cashflow.TOTAL_UPLOADS}</td>
            <td>
                <button class="btn btn-sm btn-primary js-edit-cashflow" data-info='${JSON.stringify(cashflow)}'><i class="fas fa-upload"></i></button>
            </td>
        </tr>`;

        return row;
    }

    bindDomTableAndFilterEvents() {
        let self = this;
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchCashFlowList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchCashFlowList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchCashFlowList();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-financial-cash-flow-registrations-branches-selector').change(function() {
            self.selectedBranch = $(this).val();
            // Caso tenha selecinado uma filial, mostra o campo para buscar pelo nome do paciente
            if (self.selectedBranch != '') {
                self.fetchCashFlowList();
            } else {
                self.selectedBranch = -1;
            }
        });

        $('#cashflow_create_branch').change(function() {
            self.selectedBranch = $(this).val();
        });

        $('#cashflow_edit_branch').change(function() {
            self.selectedBranch = $(this).val();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-financial-cash-flow-registrations-start-date-input', function(e) {
            self.startDate = $(this).val();
            if (self.startDate === '')
                self.startDate = null;
            self.fetchCashFlowList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-financial-cash-flow-registrations-end-date-input', function(e) {
            self.endDate = $(this).val();
            if (self.endDate === '')
                self.endDate = null;
            self.fetchCashFlowList();
        });

        // Detecta usuário configurando filtro qtd de registros por página
        $(document).on('change', '.js-financial-cash-flow-per-page', function() {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchCashFlowList();
        });
    }

    bindDomEvents() {
        let self = this;

        $('.js-financial-cash-flow-create-form').on('submit', function(e) {
            e.preventDefault();

            let data = $(this).serializeArray();

            let selfBtn = $(this).find('button[type="submit"]');
            selfBtn.prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/financial/cash-flow/create',
                data: data,
                successCallback: function(res) {
                    selfBtn.prop('disabled', false);
                    window.toast({
                        error: res.error,
                        text: res.message
                    });

                    if (!res.error) {
                        $('.js-financial-cash-flow-create-form').trigger('reset');
                        $('#modal-financial-cash-flow-create').modal('hide');
                        self.fetchCashFlowList();
                    }
                },
                errorCallback: function(err) {
                    selfBtn.prop('disabled', false);
                    console.log(err);
                }
            });
        });
    }

    bindDOMCashFlowUploads() {
        this.selectedCashFlow = null;
        let self = this;

        // Detecta clique para visualizar lista de uploads de um contrato
        $(document).on('click', '.js-edit-cashflow', function() {
            let cashflowData = $(this).data('info');
            self.selectedCashFlow = cashflowData;
            self.fetchCurrentCashFlowViewUploads(cashflowData.ID);
            $('#modal-financial-cash-flow-upload').modal('show');
        });
        
        // Detecta clique para subir um contrato do paciente
        $(document).on('submit', '.js-financial-cash-flow-upload-form', function(e) {
            e.preventDefault();
            let botEditData = new FormData(this);
            botEditData.append('cashflow_id', self.selectedCashFlow.ID);

            let selfBtn = $(this).find('button[type="submit"]');
            selfBtn.prop('disabled', true);
            
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/financial/cash-flow/upload',
                data: botEditData,
                processData: false,
                contentType: false,
                formBlockContainer: ".modal-financial-cash-flow-upload-dialog",
                formElement: '.js-financial-cash-flow-upload-form',
                successCallback: function(body) {
                    selfBtn.prop('disabled', false);
                    window.toast({
                        error: body.error,
                        text: body.message
                    });

                    if (!body.error) {
                        $('.js-financial-cash-flow-upload-form').trigger('reset');
                        self.fetchCurrentCashFlowViewUploads(self.selectedCashFlow.ID);
                    }
                },
                errorCallback: function(err) {
                    selfBtn.prop('disabled', false);
                    console.log(err);
                }
            });
        });

        // Detecta clique para excluir um contrato registrado
        $(document).on('click', '.js-financial-cash-flow-delete-upload-file', function() {
            let uploadId = $(this).data('upload-id'),
                cashflowId = $(this).data('cashflow-id');

            if (!userHasRole('ADMIN'))
                return window.toast({
                    error: true,
                    text: 'Apenas administradores podem remover Contratos.'
                })

            if (!window.confirm('Deseja realmente excluir este arquivo?')) {
                return;
            }

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/financial/cash-flow/upload_delete',
                data: {
                    upload_id: uploadId,
                    cashflow_id: cashflowId
                },
                successCallback: function(body) {
                    window.toast({
                        error: body.error,
                        text: body.message
                    });

                    if (!body.error) {
                        self.fetchCurrentCashFlowViewUploads(cashflowId);
                    }
                },
                errorCallback: function(err) {
                    console.log(err);
                }
            })
        });
    }

    fetchCurrentCashFlowViewUploads(cashflow_id) {
        $('.js-financial-cash-flow-uploads-list').html(`<tr><td colspan="4">Carregando...</td></tr>`);
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/financial/cash-flow/uploads',
            data: {
                cashflowId: cashflow_id
            },
            successCallback: function(res) {
                if (res.error) {
                    window.toast({
                        error: true,
                        text: res.message
                    })
                } else {
                    let html = '';
                    for(let i in res.data) {
                        let upload = res.data[i];
                        html += `
                            <tr>
                                <td data-label="Arquivo">${upload.NOME_ARQUIVO}</td>
                                <td data-label="Antigo?">${upload.ARQUIVO.indexOf('thequiro') !== -1 ? 'Novo' : 'Antigo'}</td>
                                <td data-label="Arquivo"><a href="${upload.ARQUIVO}" target="new" class="btn btn-primary btn-sm"><i class="fas fa-download"></i> &nbsp;Baixar</a></td>
                                <td data-label="Excluir">
                                    ${userHasRole('ADMIN') ? `<a href="javascript:void(0);" data-upload-id="${upload.ID}" data-cashflow-id="${cashflow_id}" class="btn btn-danger btn-sm js-financial-cash-flow-delete-upload-file"><i class="fas fa-trash"></i> &nbsp;Excluir</a>` : ``}	
                                </td>
                            </tr>
                        `;
                    }
                    if (res.data.length === 0) {
                        html += `<tr><td colspan="4">Nenhum upload foi realizado</tr></td>`
                    }
                    $('.js-financial-cash-flow-uploads-list').html(html);
                }
            },
            errorCallback: function(err) {
            }
        });
    }
}